import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import CustomTextField from "./CustomTextField";
import SectionHeading from "./SectionHeading";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI308_2 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    assessedEnvironmentalImpacts: "",
    withAdverseEnvironmentalImpacts: "",
    supplyChainAdverseImpacts: "",
    agreedImprovementsPercentage: "",
    supplierTerminationsPercentage: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI300&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI300?.supplyChainImpactsActions || {};
        setFormData({
          assessedEnvironmentalImpacts: data.assessedEnvironmentalImpacts || "",
          withAdverseEnvironmentalImpacts:
            data.withAdverseEnvironmentalImpacts || "",
          supplyChainAdverseImpacts: data.supplyChainAdverseImpacts || "",
          agreedImprovementsPercentage: data.agreedImprovementsPercentage || "",
          supplierTerminationsPercentage:
            data.supplierTerminationsPercentage || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (
      isNaN(formData.assessedEnvironmentalImpacts) ||
      formData.assessedEnvironmentalImpacts < 0
    ) {
      newErrors.assessedEnvironmentalImpacts =
        "Please enter valid numeric value";
      formIsValid = false;
    }

    // if (!formData.withAdverseEnvironmentalImpacts) {
    //   newErrors.withAdverseEnvironmentalImpacts = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.supplyChainAdverseImpacts) {
    //   newErrors.supplyChainAdverseImpacts = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.agreedImprovementsPercentage) {
    //   newErrors.agreedImprovementsPercentage = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.supplierTerminationsPercentage) {
    //   newErrors.supplierTerminationsPercentage = "This field is required";
    //   formIsValid = false;
    // }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;
      const payload = {
        type: "GRI300",
        supplyChainImpactsActions: {
          ...formData,
        },
        submitted308_2: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/401-1/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/401-1/${id}`);
    }
  };

  const renderContent = ({hide}) => (
     <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      {!hide && <p className={styles.section_heading}>308 : Supplier Env</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1.5rem" : "0" }}>
        308-2 : Negative environmental impacts in the supply chain and actions
        taken
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading text="a. Number of suppliers assessed for environmental impacts" />
        <CustomTextField
          value={formData.assessedEnvironmentalImpacts}
          placeholder="Enter Number"
          onChange={(e) =>
            handleInputChange("assessedEnvironmentalImpacts", e.target.value)
          }
          error={errors.assessedEnvironmentalImpacts}
          helperText={errors.assessedEnvironmentalImpacts}
          disabled={disabled}
        />

        <SectionHeading text="b. How many suppliers have been identified as having significant actual and potential adverse environmental impacts?" />
        <CustomTextField
          value={formData.withAdverseEnvironmentalImpacts}
          onChange={(e) =>
            handleInputChange("withAdverseEnvironmentalImpacts", e.target.value)
          }
          error={errors.withAdverseEnvironmentalImpacts}
          helperText={errors.withAdverseEnvironmentalImpacts}
          disabled={disabled}
        />

        <SectionHeading text="c. In the supply chain, what significant actual and potential adverse environmental impacts have been identified?" />
        <CustomTextField
          value={formData.supplyChainAdverseImpacts}
          onChange={(e) =>
            handleInputChange("supplyChainAdverseImpacts", e.target.value)
          }
          error={errors.supplyChainAdverseImpacts}
          helperText={errors.supplyChainAdverseImpacts}
          disabled={disabled}
        />

        <SectionHeading text="d. What percentage of suppliers, identified with significant actual and potential negative environmental impacts, have agreed upon improvements following assessment?" />
        <CustomTextField
          value={formData.agreedImprovementsPercentage}
          onChange={(e) =>
            handleInputChange("agreedImprovementsPercentage", e.target.value)
          }
          error={errors.agreedImprovementsPercentage}
          helperText={errors.agreedImprovementsPercentage}
          disabled={disabled}
        />

        <SectionHeading text="e. What percentage of suppliers, identified with significant actual and potential negative environmental impacts, had their relationships terminated as a result of assessment, and what were the reasons for termination?" />
        <CustomTextField
          value={formData.supplierTerminationsPercentage}
          onChange={(e) =>
            handleInputChange("supplierTerminationsPercentage", e.target.value)
          }
          error={errors.supplierTerminationsPercentage}
          helperText={errors.supplierTerminationsPercentage}
          disabled={disabled}
        />

        {/* Submit Button */}
       
        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
   <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}

          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI308_2;
